import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
const AUTH_KEY = "adminAuth";

// ── auth (replaces the PHP $_SESSION sessionId / organizationId / userId) ──
export const getAuth = () => {
  try {
    const auth = JSON.parse(sessionStorage.getItem(AUTH_KEY) || "null");
    return auth && auth.sessionId && auth.organizationId ? auth : null;
  } catch {
    return null;
  }
};
export const setAuth = (auth) => sessionStorage.setItem(AUTH_KEY, JSON.stringify(auth));
export const clearAuth = () => sessionStorage.removeItem(AUTH_KEY);
export const isSuperadmin = () => getAuth()?.sessionId === "admin";

// the API reads "Bearer <sessionId>&<organizationId>"
const authHeader = () => {
  const auth = getAuth();
  return auth ? { Authorization: `Bearer ${auth.sessionId}&${auth.organizationId}` } : {};
};

const post = async (path, body, config = {}) => {
  try {
    const { data } = await axios.post(`${BASE_URL}/${path}`, body, {
      ...config,
      headers: { ...authHeader(), ...(config.headers || {}) },
    });
    return data;
  } catch (err) {
    const data = err.response?.data;
    throw new Error(data?.error || data?.message || err.message || "Request failed");
  }
};

// ── themes ──
export const superadminLogin = (password) => post("superadminLogin", { password });
export const fetchAllThemes = async () => (await post("fetchAllThemes", {})).data || [];
export const fetchThemeData = async (currentTheme) => (await post("fetchThemeData", { currentTheme })).data || {};
export const selectTheme = (themeName) => post("selectTheme", { themeName });
export const deleteTheme = (themeName) => post("deleteTheme", { themeName });

// data: { target: value, ... }; arrays are stored PHP-serialized by the API
export const updateMultiple = (currentTheme, data) => post("updateMultiple", { currentTheme, data });

// files: { thumbnail, logo, desktopBg, mobileBg } (File objects); themeName is only sent when editing
export const saveThemeWithMedia = (path, { themeName, name, description, files }) => {
  const form = new FormData();
  if (themeName) form.append("themeName", themeName);
  form.append("extraData", JSON.stringify({ themeName: name, themeDescription: description }));
  Object.entries(files).forEach(([field, file]) => file && form.append(field, file));
  return post(path, form);
};
export const uploadNewTheme = (args) => saveThemeWithMedia("uploadNewTheme", args);
export const updateThemeMedia = (args) => saveThemeWithMedia("updateThemeMedia", args);

export const uploadThemeImage = (themeName, target, file) => {
  const form = new FormData();
  form.append("themeName", themeName);
  form.append("target", target);
  form.append("file", file);
  return post("uploadThemeImage", form);
};
